module.exports = __webpack_public_path__ + "static/dataanalytics1-308058c63b6645a307a5508b902b0fc9.png";